
import Vue from "vue"
import PositionForm from "@/components/PositionForm.vue"

export default Vue.extend({
  components: {
    PositionForm,
  },
  mounted() {
    document.title = this.$vuetify.lang.t("$vuetify.tab_titles.create_position")
  }
})
